import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Autosuggest from "components/Autosuggest";

import ArticlesLang from "pages/articles/lang";
import { actionArticlesCleanSuggestions, actionArticlesSuggest, selectArticlesState } from "pages/articles";

const ArticlesSuggestions = ({
  onSelect,
  value: sValue = "",
  label: sLabel = null,
  className: sClassName,
  clean: bClean = false,
  disabled: bDisabled = false,
  placeholder: sPlaceHolder = null,
  containerClassName: sContainerClassName = null,
}) => {
  const oDispatch = useDispatch();
  const { aSuggestions } = useSelector(selectArticlesState);

  const onSuggestionsFetchRequested = (oEvent) => {
    oDispatch(actionArticlesSuggest(oEvent.value));
  };

  const onCleanSuggestions = () => oDispatch(actionArticlesCleanSuggestions());

  useEffect(() => {
    onCleanSuggestions();
  }, [bClean]);

  return <div className={sContainerClassName || null}>
    <Autosuggest
      value={sValue}
      label={sLabel}
      clean={bClean}
      onSelect={onSelect}
      disabled={bDisabled}
      className={sClassName}
      suggestions={aSuggestions}
      onSuggestionsClearRequested={onCleanSuggestions}
      placeholder={sPlaceHolder ?? ArticlesLang.Labels.article}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
    />
  </div>;
};

export default ArticlesSuggestions;
